<template>
  <div id="data-list-list-view" class="data-list-container">

    <data-view-sidebar-document-types :isSidebarActive="addNewDataSidebarDocumentTypes" @closeSidebar="toggleDataSidebarDocumentTypes" :data="sidebarDataDocumentTypes" v-on:closeSidebarSuccess="updateDocumentTypesIndex"/>

    <vs-table ref="table" v-model="selected" pagination :max-items="itemsPerPage" search :data="visaDocumentTypes">

      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

        <div class="flex flex-wrap-reverse items-center data-list-btn-container">

          <!-- ADD NEW -->
          <div class="btn-add-new p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary" @click="addNewData">
              <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
              <span class="ml-2 text-base text-primary">Agregar Nuevo Documento</span>
          </div>
        </div>

        <!-- ITEMS PER PAGE -->
        <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4 items-per-page-handler">
          <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
            <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ visaDocumentTypes.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : visaDocumentTypes.length }} of {{ queriedItems }}</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
          <vs-dropdown-menu>

            <vs-dropdown-item @click="itemsPerPage=25">
              <span>25</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=50">
              <span>50</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=100">
              <span>100</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=200">
              <span>200</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <template slot="thead">
        <vs-th sort-key="id_visa_document_type">ID</vs-th>
        <vs-th sort-key="name_visa_document_type">NOMBRE DOCUMENTO</vs-th>
        <vs-th sort-key="flag_active_visa_type">APLICABLE A VISADOS</vs-th>
        <vs-th>Opciones</vs-th>
      </template>

        <template slot-scope="{data}">
          <tbody>
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td>
                <p class="product-name font-medium">{{ tr.id_visa_document_type }}</p>
              </vs-td>
              <vs-td>
                <p class="product-name font-medium">{{ tr.name_visa_document_type }}</p>
              </vs-td>
              <vs-td>
                <p class="font-medium">
                <ul>
                  <li v-for="(item, index) in tr.visa_types.split(',')" :key="index" >
                    {{item}}
                  </li>
                </ul>
                </p>
              </vs-td>
              <vs-td class="whitespace-no-wrap">
                <feather-icon icon="EditIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current" @click.stop="editData(tr)" />
                <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2" @click.stop="deleteData(tr.id_visa_document_type)" />
              </vs-td>

            </vs-tr>
          </tbody>
        </template>
    </vs-table>
  </div>
</template>

<script>
import DocumentTypesDataViewSidebar from './DocumentTypesDataViewSidebar.vue'

export default {
  components: {
    DataViewSidebarDocumentTypes: DocumentTypesDataViewSidebar
  },
  data () {
    return {
      selected: [],
      // products: [],
      itemsPerPage: 100,
      isMounted: false,

      // Data Sidebar Document Types
      addNewDataSidebarDocumentTypes: false,
      sidebarDataDocumentTypes: {}
    }
  },
  computed: {
    currentPage () {
      if (this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },
    visaTypes () {
      return this.$store.state.visaTypes
    },
    visaDocumentTypes () {
      return this.$store.state.visaDocumentTypes
    },
    queriedItems () {
      return this.$refs.table ? this.$refs.table.queriedResults.length : this.visaDocumentTypes.length
    }
  },
  methods: {
    updateDocumentTypesIndex () {
      this.$store.dispatch('fetchVisaDocumentTypes')
    },
    addNewData () {
      this.sidebarDataDocumentTypes = {}
      this.toggleDataSidebarDocumentTypes(true)
    },
    deleteData (id_visa_document_type) {
      this.$store.dispatch('removeItemVisaDocumentType', id_visa_document_type)
        .then(() => {
          this.$vs.notify({
            title: 'Documento borrado',
            text: 'Se ha borrado un documento para visados',
            color: 'success',
            iconPack: 'feather',
            icon:'icon-check',
            time: 4000
          })
        })
        .then(() => {
          this.updateDocumentTypesIndex()
        })
        .catch(err => { 
          console.error(err) 
          const mensaje_error = err.response.data.errors
          if (typeof mensaje_error === 'string') {
            this.$vs.notify({
              title: 'Error',
              text: `${mensaje_error}`,
              color: 'warning',
              iconPack: 'feather',
              icon:'icon-x-circle',
              time: 6000
            })
          } else {
            const array_errors = Object.entries(mensaje_error)
            for (let i = 0; i < array_errors.length; i++) {
              this.$vs.notify({
                title: 'Error',
                text: `${array_errors[i][1][0]}`,
                iconPack: 'feather',
                icon: 'icon-x-circle',
                color: 'warning',
                time: 6000
              })
            }
          }
        })
    },
    editData (data) {
      this.sidebarDataDocumentTypes = data
      this.toggleDataSidebarDocumentTypes(true)
    },
    toggleDataSidebarDocumentTypes (val = false) {
      this.addNewDataSidebarDocumentTypes = val
    }
  },
  created () {
    this.$store.dispatch('fetchVisaDocumentTypes')
  },
  mounted () {
    this.isMounted = true
  }
}
</script>

<style lang="scss">
#data-list-list-view {
  .vs-con-table {

    /*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search{
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr{
          box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
          td{
            padding: 20px;
            &:first-child{
              border-top-left-radius: .5rem;
              border-bottom-left-radius: .5rem;
            }
            &:last-child{
              border-top-right-radius: .5rem;
              border-bottom-right-radius: .5rem;
            }
          }
          td.td-check{
            padding: 20px !important;
          }
      }
    }

    .vs-table--thead{
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text{
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check{
        padding: 0 15px !important;
      }
      tr{
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
